export const pad = (value: number, length: number) => String(value).padStart(length, '0');
